import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-fluid" }
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "Chọn khoản thời gian thống kê báo cáo: ", -1)
const _hoisted_5 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Không có báo cáo. ")
const _hoisted_7 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_8 = { class: "p-fluid" }
const _hoisted_9 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_10 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_11 = { class: "p-fluid" }
const _hoisted_12 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_13 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, "Từ thời gian: ", -1)
const _hoisted_15 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", null, "Đến thời gian: ", -1)
const _hoisted_17 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"13px","font-style":"oblique","font-weight":"bold"} }, "Số tồn cũ = Số tồn đầu + Số nhập - Số cấp - Số hủy", -1)
const _hoisted_19 = { class: "p-field p-col p-col-12 smbt" }
const _hoisted_20 = { class: "p-field p-col p-col-12 smbt" }
const _hoisted_21 = { class: "p-fluid" }
const _hoisted_22 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_23 = { class: "p-field p-col p-col-12 p-md-8 p-lg-8" }
const _hoisted_24 = { class: "flex flex-col items-center w-full gap-4 border-b border-surface-200 dark:border-surface-700" }
const _hoisted_25 = { class: "p-field p-col-12 p-sm-12 p-md-12" }
const _hoisted_26 = { id: "loadingExport" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", null, "Đang tải dữ liệu, vui lòng chờ...", -1)
const _hoisted_28 = { class: "p-fluid" }
const _hoisted_29 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_30 = { class: "p-field p-col p-col-12 p-md-8 p-lg-8" }
const _hoisted_31 = { class: "flex flex-col items-center w-full gap-4 border-b border-surface-200 dark:border-surface-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Row = _resolveComponent("Row")!
  const _component_ColumnGroup = _resolveComponent("ColumnGroup")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Panel, { header: "BÁO CÁO TÌNH HÌNH SỬ DỤNG VẮC XIN VÀ DỤNG CỤ TIÊM CHỦNG" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_Calendar, {
                id: "date",
                modelValue: $setup.dateTinhHinh,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.dateTinhHinh) = $event)),
                selectionMode: "range",
                dateFormat: "dd/mm/yy",
                showButtonBar: true,
                showIcon: true,
                manualInput: false,
                monthNavigator: true,
                yearNavigator: true,
                yearRange: "2000:2100",
                onDateSelect: _cache[1] || (_cache[1] = ($event: any) => ($setup.selectCalendarTinhHinh())),
                onClearClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.clearCalendar()))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_DataTable, {
                value: $setup.listBaoCao,
                paginator: true,
                stripedRows: "",
                rows: 10,
                rowsPerPageOptions: [10,25,50],
                rowHover: true,
                paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                globalFilterFields: ['tuNgay','denNgay','nguoiBaoCaoCao','donViBaoCao'],
                currentPageReportTemplate: "Có tất cả {totalRecords} báo cáo",
                filters: _ctx.filters,
                "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters) = $event)),
                style: {"font-size":"13px"}
              }, {
                empty: _withCtx(() => [
                  _hoisted_6
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Column, {
                    field: "tuNgay",
                    dataType: "date",
                    header: "Từ ngày",
                    sortable: ""
                  }, {
                    body: _withCtx(({data}) => [
                      _createTextVNode(_toDisplayString($setup.formatDateTime(data.tuNgay)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "denNgay",
                    dataType: "date",
                    header: "Đến ngày",
                    sortable: ""
                  }, {
                    body: _withCtx(({data}) => [
                      _createTextVNode(_toDisplayString($setup.formatDateTime(data.denNgay)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "thoiGianBaoCao",
                    dataType: "date",
                    header: "Thời gian báo cáo",
                    sortable: ""
                  }, {
                    body: _withCtx(({data}) => [
                      _createTextVNode(_toDisplayString($setup.formatDateTimeHours(data.thoiGianBaoCao)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "nguoiBaoCaoCao",
                    header: "Người báo cáo",
                    sortable: ""
                  }),
                  _createVNode(_component_Column, {
                    field: "donViBaoCao",
                    header: "Đơn vị",
                    sortable: ""
                  }),
                  _createVNode(_component_Column, {
                    field: "",
                    header: ""
                  }, {
                    body: _withCtx(({data}) => [
                      _createVNode(_component_Button, {
                        label: "Chi tiết báo cáo",
                        icon: "pi pi-eye",
                        onClick: ($event: any) => ($setup.loadDBTinhHinh(data.id)),
                        severity: "secondary",
                        raised: ""
                      }, null, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value", "filters"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_Dialog, {
                visible: $setup.baoCaoTinhHinh,
                "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => (($setup.baoCaoTinhHinh) = $event)),
                style: { width: '98vw'},
                breakpoints: { '1500px': '98vw', '1150px': '100vw' }
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_Panel, { header: "Thời gian báo cáo" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, [
                                  _hoisted_14,
                                  _createVNode(_component_Calendar, {
                                    modelValue: $setup.baoCao.tuNgay,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.baoCao.tuNgay) = $event)),
                                    touchUI: "",
                                    view: "date",
                                    dateFormat: "dd/mm/yy"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _createElementVNode("div", _hoisted_15, [
                                  _hoisted_16,
                                  _createVNode(_component_Calendar, {
                                    modelValue: $setup.baoCao.denNgay,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.baoCao.denNgay) = $event)),
                                    touchUI: "",
                                    view: "date",
                                    dateFormat: "dd/mm/yy"
                                  }, null, 8, ["modelValue"])
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _hoisted_18,
                        _createVNode(_component_DataTable, {
                          value: $setup.baoCao.baoCaos,
                          showGridlines: "",
                          rows: 40,
                          rowHover: true,
                          style: {"font-size":"14px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ColumnGroup, { type: "header" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Column, {
                                      header: "TT",
                                      rowspan: 3,
                                      style: {"width":"5px"}
                                    }),
                                    _createVNode(_component_Column, {
                                      header: "Lọai vắc xin vật tư tiêm chủng",
                                      rowspan: 3
                                    }),
                                    _createVNode(_component_Column, {
                                      header: "Số đối tượng được tiêm",
                                      rowspan: 3
                                    }),
                                    _createVNode(_component_Column, {
                                      header: "Số tồn cũ (liều, cái)\t",
                                      colspan: 2
                                    }),
                                    _createVNode(_component_Column, {
                                      header: "Số nhận mới (liều, cái)",
                                      rowspan: 3
                                    }),
                                    _createVNode(_component_Column, {
                                      header: "Số cấp phát (liều, cái)",
                                      rowspan: 3
                                    }),
                                    _createVNode(_component_Column, {
                                      header: "Số sử dụng (tính theo liều các lọ đã mở)",
                                      rowspan: 3
                                    }),
                                    _createVNode(_component_Column, {
                                      header: "Hệ số sử dụng",
                                      rowspan: 3
                                    }),
                                    _createVNode(_component_Column, {
                                      header: "Số hủy (số liều hủy nguyên lọ vắc xin)",
                                      colspan: 2
                                    }),
                                    _createVNode(_component_Column, {
                                      header: "Số hiện còn (liều, cái)",
                                      colspan: 4
                                    }),
                                    _createVNode(_component_Column, {
                                      header: "Số hiện còn sử dụng mấy tháng",
                                      rowspan: 3
                                    }),
                                    _createVNode(_component_Column, {
                                      header: "Ghi chú",
                                      rowspan: 3
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Column, {
                                      header: "Của đơn vị",
                                      rowspan: 2
                                    }),
                                    _createVNode(_component_Column, {
                                      header: "Của tuyến dưới",
                                      rowspan: 2
                                    }),
                                    _createVNode(_component_Column, {
                                      header: "Tại kho đơn vị",
                                      rowspan: 2
                                    }),
                                    _createVNode(_component_Column, {
                                      header: "Tại tuyến dưới",
                                      rowspan: 2
                                    }),
                                    _createVNode(_component_Column, {
                                      header: "Tại kho đơn vị",
                                      colspan: 2
                                    }),
                                    _createVNode(_component_Column, {
                                      header: "Tuyến dưới",
                                      colspan: 2
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Column, {
                                      header: "Số lượng",
                                      colspan: 1
                                    }),
                                    _createVNode(_component_Column, {
                                      header: "Hạn dùng gần nhất",
                                      colspan: 1
                                    }),
                                    _createVNode(_component_Column, {
                                      header: "Số lượng",
                                      colspan: 1
                                    }),
                                    _createVNode(_component_Column, {
                                      header: "Hạn dùng gần nhất",
                                      colspan: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_Column, {
                              header: "",
                              style: {"width":"5px"}
                            }, {
                              body: _withCtx((slotProps) => [
                                _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_Column, {
                              field: "tongSo",
                              header: "Tổng số"
                            }, {
                              body: _withCtx((slotProps) => [
                                _createElementVNode("label", null, _toDisplayString(slotProps.data.loaiVacxin), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_Column, {
                              field: "soTrucThuoc",
                              header: ""
                            }, {
                              body: _withCtx((slotProps) => [
                                _createVNode(_component_InputNumber, {
                                  inputId: "integeronly",
                                  modelValue: slotProps.data.soDoiTuongDuocTiem,
                                  "onUpdate:modelValue": ($event: any) => ((slotProps.data.soDoiTuongDuocTiem) = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_Column, {
                              field: "soCSCoYeuToCoHai",
                              header: ""
                            }, {
                              body: _withCtx((slotProps) => [
                                _createVNode(_component_InputNumber, {
                                  inputId: "integeronly",
                                  modelValue: slotProps.data.donVi,
                                  "onUpdate:modelValue": ($event: any) => ((slotProps.data.donVi) = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_Column, {
                              field: "tongSoCoSo",
                              header: ""
                            }, {
                              body: _withCtx((slotProps) => [
                                _createVNode(_component_InputNumber, {
                                  inputId: "integeronly",
                                  modelValue: slotProps.data.tuyenDuoi,
                                  "onUpdate:modelValue": ($event: any) => ((slotProps.data.tuyenDuoi) = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_Column, {
                              field: "tongNuCoSo",
                              header: ""
                            }, {
                              body: _withCtx((slotProps) => [
                                _createVNode(_component_InputNumber, {
                                  inputId: "integeronly",
                                  modelValue: slotProps.data.soNhanMoi,
                                  "onUpdate:modelValue": ($event: any) => ((slotProps.data.soNhanMoi) = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_Column, {
                              field: "tongSoCoSoCoYeuTo",
                              header: ""
                            }, {
                              body: _withCtx((slotProps) => [
                                _createVNode(_component_InputNumber, {
                                  inputId: "integeronly",
                                  modelValue: slotProps.data.soCapPhat,
                                  "onUpdate:modelValue": ($event: any) => ((slotProps.data.soCapPhat) = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_Column, {
                              field: "tongNuCoSoCoYeuTo",
                              header: ""
                            }, {
                              body: _withCtx((slotProps) => [
                                _createVNode(_component_InputNumber, {
                                  inputId: "integeronly",
                                  modelValue: slotProps.data.soSuDung,
                                  "onUpdate:modelValue": ($event: any) => ((slotProps.data.soSuDung) = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_Column, {
                              field: "tongSoLDTiepXucTrucTiep",
                              header: ""
                            }, {
                              body: _withCtx((slotProps) => [
                                _createVNode(_component_InputNumber, {
                                  inputId: "integeronly",
                                  modelValue: slotProps.data.heSoSuDung,
                                  "onUpdate:modelValue": ($event: any) => ((slotProps.data.heSoSuDung) = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_Column, {
                              field: "tongSoLDTiepXucTrucTiep",
                              header: ""
                            }, {
                              body: _withCtx((slotProps) => [
                                _createVNode(_component_InputNumber, {
                                  inputId: "integeronly",
                                  modelValue: slotProps.data.taiKhoDonVi,
                                  "onUpdate:modelValue": ($event: any) => ((slotProps.data.taiKhoDonVi) = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_Column, {
                              field: "tongSoLDTiepXucTrucTiep",
                              header: ""
                            }, {
                              body: _withCtx((slotProps) => [
                                _createVNode(_component_InputNumber, {
                                  inputId: "integeronly",
                                  modelValue: slotProps.data.taiTuyen,
                                  "onUpdate:modelValue": ($event: any) => ((slotProps.data.taiTuyen) = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_Column, {
                              field: "tongSoLDTiepXucTrucTiep",
                              header: ""
                            }, {
                              body: _withCtx((slotProps) => [
                                _createVNode(_component_InputNumber, {
                                  inputId: "integeronly",
                                  modelValue: slotProps.data.soLuongDonVi,
                                  "onUpdate:modelValue": ($event: any) => ((slotProps.data.soLuongDonVi) = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_Column, {
                              field: "tongSoLDTiepXucTrucTiep",
                              header: "",
                              style: {"width":"100px"}
                            }, {
                              body: _withCtx((slotProps) => [
                                _createVNode(_component_Calendar, {
                                  modelValue: slotProps.data.hanDungGanNhatDonVi,
                                  "onUpdate:modelValue": ($event: any) => ((slotProps.data.hanDungGanNhatDonVi) = $event),
                                  touchUI: "",
                                  view: "date",
                                  dateFormat: "dd/mm/yy"
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_Column, {
                              field: "tongSoLDTiepXucTrucTiep",
                              header: ""
                            }, {
                              body: _withCtx((slotProps) => [
                                _createVNode(_component_InputNumber, {
                                  inputId: "integeronly",
                                  modelValue: slotProps.data.soLuongTuyenDuoi,
                                  "onUpdate:modelValue": ($event: any) => ((slotProps.data.soLuongTuyenDuoi) = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_Column, {
                              field: "tongSoLDTiepXucTrucTiep",
                              header: "",
                              style: {"width":"100px"}
                            }, {
                              body: _withCtx((slotProps) => [
                                _createVNode(_component_Calendar, {
                                  modelValue: slotProps.data.hanDungGanNhatTuyenDuoi,
                                  "onUpdate:modelValue": ($event: any) => ((slotProps.data.hanDungGanNhatTuyenDuoi) = $event),
                                  touchUI: "",
                                  view: "date",
                                  dateFormat: "dd/mm/yy"
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_Column, {
                              field: "tongSoLDTiepXucTrucTiep",
                              header: ""
                            }, {
                              body: _withCtx((slotProps) => [
                                _createVNode(_component_InputNumber, {
                                  inputId: "integeronly",
                                  modelValue: slotProps.data.soHienConSuDung,
                                  "onUpdate:modelValue": ($event: any) => ((slotProps.data.soHienConSuDung) = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_Column, {
                              field: "tongSoLDTiepXucTrucTiep",
                              header: "",
                              style: {"width":"250px"}
                            }, {
                              body: _withCtx((slotProps) => [
                                _createVNode(_component_InputText, {
                                  id: "username",
                                  type: "text",
                                  modelValue: slotProps.data.ghiChu,
                                  "onUpdate:modelValue": ($event: any) => ((slotProps.data.ghiChu) = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_Button, {
                          label: "Gởi báo cáo",
                          icon: "pi pi-upload",
                          severity: "secondary",
                          raised: "",
                          onClick: $setup.addReport
                        }, null, 8, ["onClick"])
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_Button, {
                          label: "Xuất báo cáo",
                          icon: "pi pi-download",
                          severity: "info",
                          raised: "",
                          onClick: $setup.exportFileTinhHinh
                        }, null, 8, ["onClick"])
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["visible"])
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_component_ConfirmDialog, { group: "templating" }, {
            message: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("p", null, _toDisplayString(slotProps.message.message), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_Dialog, {
            header: "Đang xử lý",
            visible: $setup.loadingExport,
            "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => (($setup.loadingExport) = $event))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createVNode(_component_ProgressBar, {
                  mode: "indeterminate",
                  style: {"height":".3em"}
                })
              ])
            ]),
            _: 1
          }, 8, ["visible"]),
          _createVNode(_component_ConfirmDialog)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createVNode(_component_ConfirmDialog, { group: "templating" }, {
            message: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("p", null, _toDisplayString(slotProps.message.message), 1)
              ])
            ]),
            _: 1
          })
        ])
      ])
    ])
  ], 64))
}